exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500);", ""]);

// module
exports.push([module.id, "body{margin:0;padding:0;font-family:Roboto,sans-serif;margin-left:calc(100vw - 100%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/index.scss
// module id = 332
// module chunks = 0